/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_No_Event_SelectedInputs */

const en_image_export_preview_no_event_selected = /** @type {(inputs: Image_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No event selected for preview`)
};

const fr_image_export_preview_no_event_selected = /** @type {(inputs: Image_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun evenement selectionne pour la previsualisation`)
};

const de_image_export_preview_no_event_selected = /** @type {(inputs: Image_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Vorschau wurde kein Ereignis ausgewählt.`)
};

const it_image_export_preview_no_event_selected = /** @type {(inputs: Image_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento selezionato per l'anteprima`)
};

const ru_image_export_preview_no_event_selected = /** @type {(inputs: Image_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для предварительного просмотра не выбрано ни одного события.`)
};

const es_image_export_preview_no_event_selected = /** @type {(inputs: Image_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ningún evento seleccionado para la vista previa`)
};

const zh_cn2_image_export_preview_no_event_selected = /** @type {(inputs: Image_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择任何事件进行预览`)
};

const ja_image_export_preview_no_event_selected = /** @type {(inputs: Image_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューにイベントが選択されていません`)
};

const hi_image_export_preview_no_event_selected = /** @type {(inputs: Image_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन के लिए कोई इवेंट चयनित नहीं है`)
};

const pt_pt2_image_export_preview_no_event_selected = /** @type {(inputs: Image_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento selecionado para pré-visualização.`)
};

/**
* | output |
* | --- |
* | "No event selected for preview" |
*
* @param {Image_Export_Preview_No_Event_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_no_event_selected = /** @type {((inputs?: Image_Export_Preview_No_Event_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_No_Event_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_no_event_selected(inputs)
	if (locale === "de") return de_image_export_preview_no_event_selected(inputs)
	if (locale === "it") return it_image_export_preview_no_event_selected(inputs)
	if (locale === "ru") return ru_image_export_preview_no_event_selected(inputs)
	if (locale === "es") return es_image_export_preview_no_event_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_no_event_selected(inputs)
	if (locale === "ja") return ja_image_export_preview_no_event_selected(inputs)
	if (locale === "hi") return hi_image_export_preview_no_event_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_no_event_selected(inputs)
	return en_image_export_preview_no_event_selected(inputs)
});